import { alpha } from '@mui/material';

export const getHoverDecorationGlobalStyles = highlightColor => ({
  '.expression-outline-hover-inline': {
    backgroundColor: highlightColor,
    borderRadius: '3px',
  },
});

export const scopeReadoutStyles = {
  marginLeft: 'auto',
  fontSize: '12px',
  fontFamily: 'monospace',
  color: ({ palette }) => palette.text.secondary,
};

export const getStudioLayoutStyles = showOutline => ({
  display: 'grid',
  gridTemplateColumns: showOutline ? '1fr 300px' : '1fr',
  gap: 0,
  marginTop: '4px',
  border: ({ palette }) => `1px solid ${palette.border.input}`,
  borderRadius: '8px',
  overflow: 'hidden',
});

export const editorColumnStyles = {
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  borderRight: ({ palette }) => `1px solid ${palette.divider}`,
};

export const editorSurfaceStyles = {
  position: 'relative',
};

export const editorWrapperStyles = {
  padding: '0 14px',
  height: '200px',
  width: '100%',
  resize: 'vertical',
  overflow: 'hidden',
};

export const editorHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '8px 14px',
  borderBottom: ({ palette }) => `1px solid ${palette.divider}`,
  backgroundColor: ({ palette }) =>
    palette.mode === 'dark' ? palette.background.secondary : palette.grey[50],
  fontSize: '11px',
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
  fontWeight: 700,
  color: ({ palette }) => palette.text.secondary,
};

export const editorHeaderHintStyles = {
  textTransform: 'none',
  letterSpacing: 0,
  fontWeight: 500,
  color: ({ palette }) => palette.text.secondary,
};

export const editorHeaderSpacerStyles = {
  marginLeft: 'auto',
};

export const editorToolbarStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '8px 14px',
  borderTop: ({ palette }) => `1px solid ${palette.divider}`,
  backgroundColor: ({ palette }) =>
    palette.mode === 'dark' ? palette.background.secondary : palette.grey[50],
  flexWrap: 'wrap',
};

export const ghostButtonStyles = {
  textTransform: 'none',
  fontSize: '12.5px',
  fontWeight: 500,
  lineHeight: 1.4,
  padding: '4px 11px',
  minWidth: 0,
  borderRadius: '8px',
  color: ({ palette }) => palette.text.secondary,
  borderColor: ({ palette }) => palette.divider,
  '&:hover': {
    color: ({ palette }) => palette.primary.main,
    borderColor: ({ palette }) => palette.primary.main,
    backgroundColor: 'transparent',
  },
};

export const charCountStyles = {
  marginLeft: 'auto',
  fontSize: '12px',
  color: ({ palette }) => palette.text.secondary,
};

export const getStatusPillStyles = isError => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  borderRadius: '999px',
  padding: '3px 11px',
  fontSize: '12px',
  fontWeight: 600,
  color: ({ palette }) => (isError ? palette.error.main : palette.success.main),
  backgroundColor: ({ palette }) =>
    alpha(isError ? palette.error.main : palette.success.main, 0.16),
  border: ({ palette }) =>
    `1px solid ${alpha(isError ? palette.error.main : palette.success.main, 0.4)}`,
});

export const statusDotStyles = {
  width: '7px',
  height: '7px',
  borderRadius: '50%',
  backgroundColor: 'currentColor',
};

export const railColumnStyles = {
  minWidth: 0,
  backgroundColor: ({ palette }) => palette.background.default,
};

export const pinnedReadbackStyles = {
  borderTop: ({ palette }) => `1px solid ${palette.divider}`,
  borderLeft: ({ palette }) => `3px solid ${palette.primary.main}`,
  backgroundColor: ({ palette }) => palette.background.default,
  padding: '8px 12px',
  display: 'flex',
  gap: '8px',
  alignItems: 'flex-start',
};

export const readbackTagStyles = {
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  flexShrink: 0,
  color: ({ palette }) => palette.text.secondary,
};

export const advancedNoteStyles = {
  borderTop: ({ palette }) => `1px solid ${palette.divider}`,
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
  padding: '8px 12px',
};

export const advancedNoteBadgeStyles = {
  flexShrink: 0,
  borderRadius: '6px',
  padding: '2px 8px',
  fontWeight: 700,
  backgroundColor: ({ palette }) => alpha(palette.warning.main, 0.16),
  color: ({ palette }) => palette.warning.main,
};
